import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { AdaIntegrationFacade } from '@core/ada/facades/ada-integration.facade';

export const provideAda = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideEnvironmentInitializer(() => {
      inject(AdaIntegrationFacade);
    }),
  ]);
